import React from "react";
import styled from "@emotion/styled";


const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoContainer = styled(FlexContainer)`
  padding: 20px;
  gap: 20px;
`;

export const InfoPage = () => {
  return (
    <InfoContainer>
      <FlexContainer>
        <div>
          VITE_APP_API_URL:
        </div>
        <div>
          { import.meta.env.VITE_APP_API_URL }
        </div>
      </FlexContainer>
      <FlexContainer>
        <div>
          VITE_APP_REDIRECT_URI:
        </div>
        <div>
         { import.meta.env.VITE_APP_REDIRECT_URI }
         </div>
      </FlexContainer>
    </InfoContainer>
  );
};

export default InfoPage;
